"use client";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { PageBlockNewsletterSection } from "lib/gcms";
import { SectionTemplate } from "../section-template";
import { SubscribeForm } from "./subscribe-form";

export function Newsletter({
  title,
  subtitle,
  bg,
  color,
}: PageBlockNewsletterSection) {
  return (
    <SectionTemplate {...{ bg, color }} py="50px">
      <Flex
        alignItems="center"
        flexDirection={{ base: "column", lg: "row" }}
        justifyContent="space-between"
        w="full"
      >
        <Box
          textAlign={{ base: "center", lg: "left" }}
          maxW={{ base: "md", lg: "2xl" }}
          my={{ base: "10px", lg: "12" }}
          flex="1"
        >
          <Heading
            as={"h2"}
            fontSize={{
              base: 26,
              md: 34,
              lg: 38,
            }}
            fontWeight="bold"
            lineHeight={1.2}
          >
            {title}
          </Heading>
          <Text
            my="5"
            fontSize={{
              base: "14px",
              md: "16px",
              lg: "17px",
              xl: "18px",
            }}
            fontWeight={"normal"}
          >
            {subtitle}
          </Text>
        </Box>
        <SubscribeForm />
      </Flex>
    </SectionTemplate>
  );
}
